export class Bin {

    constructor(
        public w: number,
        public h: number
    ) {}

}
